<div id="VideoGallery">
    <div class="title">
        <h1>
            Admin Page
        </h1>
        <h2 class="secondary">
            GALLERIA VIDEO
        </h2>

    </div>
    <div class="content">
        <div class="box">
            <div class="dotted" @dragover.prevent @drop="handleDrop">
                <h3 @click="openFileManager">Drop here</h3>
                <input type="file" ref="fileInput" style="display: none;" multiple @change="onFileChange">
            </div>
        </div>
        <div v-for="video in videos" :key="video._id" class="video-container">
            <div class="box box-video">
                <div class="x-button" @click="onDeleteVideo(video._id)">
                    <img src="../../../public/x.png" />
                </div>
                <video :src="`${serverUrl}/galleria/video/${video.videoName}`" class="video" controls controlsList="nodownload"></video>               
            </div>
        </div>


    </div>

</div>